import { http } from './http';

function normalizeDateInput(dateInput) {
  if (dateInput instanceof Date) {
    const d = dateInput;
    const two = (n) => (n < 10 ? `0${n}` : String(n));
    return `${d.getFullYear()}-${two(d.getMonth() + 1)}-${two(d.getDate())}`;
  }
  if (typeof dateInput === 'string') {
    return dateInput.trim();
  }
  throw new Error('Дата должна быть строкой YYYY-MM-DD или объектом Date');
}

export async function checkOrCreateTsogByDate(dateInput) {
  const dateISO = normalizeDateInput(dateInput);
  const re = /^\d{4}-\d{2}-\d{2}$/;
  if (!re.test(dateISO)) {
    throw new Error(`Некорректный формат даты: "${dateISO}". Ожидается YYYY-MM-DD.`);
  }
  const { data } = await http.post('tsog/check/', { date: dateISO });
  return data;
}

export async function updateTsogSheet(id, payload) {
  const { data } = await http.put(`tsog/${id}/`, payload);
  return data;
}
